import { IconStarFilled } from "@tabler/icons-react";
import Text from "../UI/Text";
import styles from "./IndiceConfiance.module.css";
import { getConfidenceNote } from "../../utils/candidature";
import type { Tenant } from "../../models/tenant";
import type { Profile } from "../Profile/types";

interface IndiceConfianceProps {
  tenant: Tenant;
  /** Candidats du dossier, hors garants. */
  profiles: Profile[];
  propertyGli?: boolean;
}

export default function IndiceConfiance({
  tenant,
  profiles,
  propertyGli,
}: IndiceConfianceProps) {
  const note = getConfidenceNote({ tenant, profiles, propertyGli });
  return (
    <div className={styles.indice}>
      <IconStarFilled size={16} className={styles.star} />
      <Text as="span" weight="bold">
        {note}
      </Text>
      <Text as="span" color="muted">
        /5
      </Text>
    </div>
  );
}
